import LoginClient from "./LoginClient";

export default LoginClient;
